<template>
    <modal
        :saveAction="save"
        :title="$t(title)"
        :id="id"
        :deleteAction="source._id ? deleteAction : false"
        :actionButtons="!hideForm"
        size="lg"
        :closeButton="hideForm"
        @shown="shown() "
    >
        <div class="row align-items-center mb-2">
            <div class="col-12">
                <b-form-group :label="$t('Label')">
                    <b-form-input v-model="source.label" :placeholder="$t('Ex.: TV Adv.')"></b-form-input>
                </b-form-group>
            </div>
            <div class="col-12">
                <b-form-group :label="$t('Requires value')">
                    <b-form-checkbox v-model="source.requiresValue"></b-form-checkbox>
                </b-form-group>
            </div>
        </div>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import Editor from '@/components/Editor.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { modalMixins } from '@/mixins/modal.js'


export default {
    name: 'source-form-modal',
    props: ['id', 'saveAction', 'data'],
    mixins: [modalMixins],
    components: {
        Modal,
        Editor,
    },
    data() {
        return {

            loading: false,
            hideForm: false,
            languages: [
                { text: 'English', value: 'english' },
                { text: 'Russian', value: 'russian' },
            ],
            source: {
                language: 'russian'
            },
            title: 'Source',
        }
    },
    computed: {

    },
    mounted() {
        this.$root.$on('bv::hide::modal', (modal) => {
            this.hideForm = false;
        })
        return this.find({ query: {} }).data;

    },
    methods: {
        ...mapActions('sources', ['find', 'create', 'patch', 'remove']),

        save() {
            let promise, successMessage;
            if (this.source._id) {
                promise = this.patch([this.source._id, this.source]);
                successMessage = this.$t('Item has been updated');
            } else {
                promise = this.create(this.source);
                successMessage = this.$t('Item has been created');
            }


            promise.then(result => {
                this.$root.$emit('bv::hide::modal', this.id);
                this.$toasted.global.success({
                    message: successMessage
                });
            });
        },
        deleteAction() {

            this.remove(this.source._id).then(result => {
                this.$toasted.global.success({
                    message: this.$('source has been removed')
                });
            });
        },

        shown() {
            /* Switch back to the first tab */
            this.source = this.data;
        },
        validation(field) {
            if (this.errors && this.errors[field])
                return false
            else
                return null
        },


    },

}
</script>
<style>
.pre-formatted {
  white-space: pre;
}
</style>
